module.exports = __webpack_public_path__ + "static/media/Restaurar Ativo.4fbb3df4.svg";